(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["merivo-hero"] && !Shopify.designMode) return;
  try {
    
  /* The announcement marquee stacks above the hero, so a plain 100svh hero ends
     that far past the fold. Measure whatever sits above it and take it back, so
     the hero lands exactly on the fold the way the password page does. */
  (function () {
    var hero = document.querySelector('.merivo-hero');
    if (!hero) return;
    var sync = function () {
      hero.style.setProperty('--merivo-hero-offset', '0px');
      var top = hero.getBoundingClientRect().top + (window.pageYOffset || 0);
      hero.style.setProperty('--merivo-hero-offset', Math.max(0, Math.round(top)) + 'px');
    };
    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merivo-mixology"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init() {
      if (!('IntersectionObserver' in window)) return;
      var vids = document.querySelectorAll('.mmx__video:not([data-mmx-bound])');
      if (!vids.length) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting && !reduce) {
            if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
            v.play().catch(function () {});
          } else {
            try { v.pause(); } catch (e) {}
          }
        });
      }, { threshold: 0.25, rootMargin: '100px' });

      Array.prototype.forEach.call(vids, function (v) {
        v.setAttribute('data-mmx-bound', '');
        io.observe(v);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merivo-pair-with"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mpr]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-mpr-tab]');
      var panels = root.querySelectorAll('[data-mpr-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.mprTab;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.mprPanel === key);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merivo-proof-chain"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var track = root.querySelector('[data-mpc-track]');
      var prev  = root.querySelector('[data-mpc-prev]');
      var next  = root.querySelector('[data-mpc-next]');
      var out   = root.querySelector('[data-mpc-current]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      var map   = root.querySelector('.mpc__map');
      var fill  = root.querySelector('[data-mpc-fill]');
      var spots = root.querySelectorAll('[data-mpc-goto]');

      function sync() {
        var s = step();
        var i = s ? Math.round(track.scrollLeft / s) : 0;
        var last = track.children.length - 1;
        if (i < 0) i = 0;
        if (i > last) i = last;
        if (out) out.textContent = i + 1;
        // 2px of slack so sub-pixel scroll positions don't leave a button stuck on.
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;

        // The rail fills against the active node, not raw scroll distance, so the
        // line always lands exactly on a dot rather than between two.
        if (fill && last > 0) {
          fill.style.width = (i / last * 100) + '%';
        }
        Array.prototype.forEach.call(spots, function (b, n) {
          if (n <= i) { b.setAttribute('data-passed', ''); } else { b.removeAttribute('data-passed'); }
          if (n === i) { b.setAttribute('data-active', ''); } else { b.removeAttribute('data-active'); }
        });
      }

      Array.prototype.forEach.call(spots, function (b, n) {
        b.addEventListener('click', function () {
          var card = track.children[n];
          if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });

      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(sync, 80);
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    }

    function init() {
      var roots = document.querySelectorAll('[data-mpc-carousel]:not([data-mpc-bound])');
      Array.prototype.forEach.call(roots, function (r) {
        r.setAttribute('data-mpc-bound', '');
        setup(r);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  // ---- Station route ----
  // Node positions are solved off the path with getPointAtLength, so one
  // renderer drives both canvases: the wide desktop route and a compact
  // phone-sized one. Same diagram, different proportions.
  (function () {
    var SVGNS = 'http://www.w3.org/2000/svg';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var COMPACT_AT = 700;
    var DWELL = 2600;
    var SPREAD_H = 30, SPREAD_C = 28;   // 17 collided the cluster numbers

    function el(name, attrs) {
      var n = document.createElementNS(SVGNS, name);
      for (var k in attrs) { if (attrs[k] !== null) n.setAttribute(k, attrs[k]); }
      return n;
    }

    function build(root) {
      var svg   = root.querySelector('.mpc__route-svg');
      var paths = root.querySelectorAll('[data-mpc-path], [data-mpc-done], .mpc__arc-comet');
      var path  = root.querySelector('[data-mpc-path]');
      var done  = root.querySelector('[data-mpc-done]');
      var comet = root.querySelector('.mpc__arc-comet');
      var host  = root.querySelector('[data-mpc-stations]');
      var idxEl = root.querySelector('[data-mpc-idx]');
      var readout = root.parentNode.querySelector('[data-mpc-readout]');
      if (!svg || !path || !host || !readout) return;

      var labels = (root.dataset.mpcLabels || '').split('|').map(function (t) { return t.trim(); });
      var places = (root.dataset.mpcPlaces || '').split('|').map(function (t) { return t.trim(); });
      var reads  = readout.querySelectorAll('[data-mpc-read]');
      var n = reads.length;
      if (!n) return;

      // Consecutive steps sharing a place cluster at one pin: three locations,
      // not six stops.
      var groups = [];
      for (var i = 0; i < n; i++) {
        var last = groups[groups.length - 1];
        if (last && last.place === places[i]) { last.members.push(i); }
        else { groups.push({ place: places[i], members: [i] }); }
      }
      var G = groups.length;

      var stations = [], active = -1, compact = null;

      function lengthAt(target, axis) {
        var L = path.getTotalLength(), lo = 0, hi = L;
        for (var k = 0; k < 24; k++) {
          var mid = (lo + hi) / 2;
          if (path.getPointAtLength(mid)[axis] < target) { lo = mid; } else { hi = mid; }
        }
        return (lo + hi) / 2;
      }

      // One renderer, two geometries. Compact is the same map on a squarer
      // canvas so a phone gets the diagram, not a different diagram.
      function render(isCompact) {
        compact = isCompact;
        while (host.firstChild) { host.removeChild(host.firstChild); }
        stations = [];

        svg.setAttribute('viewBox', isCompact ? svg.dataset.vbC : svg.dataset.vbH);
        var dAttr = isCompact ? svg.dataset.dC : svg.dataset.dH;
        Array.prototype.forEach.call(paths, function (pp) { pp.setAttribute('d', dAttr); });

        // SVG r is in user units, and the viewBox scales down on a phone, so a
        // fixed r renders smaller than it measures. Derive it from the live
        // scale factor so the tap target is >= 44 CSS px at any width.
        var vb = (svg.getAttribute('viewBox') || '0 0 1200 300').split(/\s+/);
        var shown = svg.getBoundingClientRect().width || parseFloat(vb[2]);
        var scale = shown / parseFloat(vb[2]);
        var hitR = Math.max(22, Math.ceil(22 / (scale > 0 ? scale : 1)));

        var L = path.getTotalLength();
        var axis = 'x';
        var lo = isCompact ? 70 : 100, hi = isCompact ? 350 : 1100;   // 370 ran the last label off the panel
        var SPREAD = isCompact ? SPREAD_C : SPREAD_H;

        groups.forEach(function (grp, gi) {
          var target = G === 1 ? (lo + hi) / 2 : lo + gi * ((hi - lo) / (G - 1));
          var anchor = lengthAt(target, axis);
          var m = grp.members.length;
          var first = null, lastPt = null;

          grp.members.forEach(function (idx, k) {
            var off = gi === 0 ? k * SPREAD
                    : gi === G - 1 ? (k - (m - 1)) * SPREAD
                    : (k - (m - 1) / 2) * SPREAD;
            var len = Math.max(0, Math.min(L, anchor + off));
            var pt = path.getPointAtLength(len);
            var isDest = idx === n - 1;
            if (!first) first = pt;
            lastPt = pt;

            var g = el('g', {
              'class': 'mpc__station' + (isDest ? ' mpc__station--dest' : ''),
              transform: 'translate(' + pt.x.toFixed(1) + ',' + pt.y.toFixed(1) + ')',
              role: 'button', tabindex: '0',
              'aria-label': 'Step ' + (idx + 1) + ' of ' + n + ', ' + grp.place + ': ' + (labels[idx] || '')
            });
            g.appendChild(el('circle', { 'class': 'mpc__st-ring', r: isDest ? 13 : 10 }));
            g.appendChild(el('circle', { 'class': 'mpc__st-dot',  r: isDest ? 7 : 5 }));
            g.appendChild(el('circle', { 'class': 'mpc__st-hit',  r: hitR }));  // >= 44 CSS px

            var num = el('text', { 'class': 'mpc__st-num', y: isCompact ? -16 : -26 });
            num.textContent = (idx + 1 < 10 ? '0' : '') + (idx + 1);
            g.appendChild(num);
            host.appendChild(g);
            stations.push({ g: g, t: len / L });
          });

            var x0 = first.x, x1 = lastPt.x;
            var yb = Math.max(first.y, lastPt.y);
            var br1 = isCompact ? 14 : 22, br2 = isCompact ? 20 : 30;
            var lab1 = isCompact ? 30 : 46, lab2 = isCompact ? 36 : 54;
            if (m > 1) {
              host.appendChild(el('path', {
                'class': 'mpc__place-bracket',
                d: 'M ' + x0.toFixed(1) + ' ' + (yb + br1) + ' L ' + x0.toFixed(1) + ' ' + (yb + br2) +
                   ' L ' + x1.toFixed(1) + ' ' + (yb + br2) + ' L ' + x1.toFixed(1) + ' ' + (yb + br1)
              }));
            }
            var plh = el('text', {
              'class': 'mpc__place-label',
              x: ((x0 + x1) / 2).toFixed(1), y: yb + (m > 1 ? lab2 : lab1)
            });
            plh.textContent = (grp.place || '').toUpperCase();
            host.appendChild(plh);
        });

        stations.forEach(function (st, k) {
          st.g.addEventListener('click', function () { hold(); go(k); });
          st.g.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hold(); go(k); }
          });
        });

        var restore = active;
        active = -1;
        go(restore < 0 ? 0 : restore);
      }

      function travel(fromT, toT) {
        if (!comet || reduce) return;
        comet.style.transition = 'none';
        comet.style.strokeDashoffset = (-fromT * 1000).toFixed(1);
        void comet.getBoundingClientRect();  // flush, or both writes collapse
        comet.style.transition = 'stroke-dashoffset ' + Math.round(DWELL * 0.55) + 'ms cubic-bezier(0.45, 0, 0.15, 1)';
        comet.style.strokeDashoffset = (-toT * 1000).toFixed(1);
      }

      function go(i) {
        if (i < 0 || i >= n || i === active || !stations.length) return;
        var prev = active;
        active = i;
        travel(prev < 0 ? stations[i].t : stations[prev].t, stations[i].t);
        stations.forEach(function (st, k) {
          if (k <= i) { st.g.setAttribute('data-passed', ''); } else { st.g.removeAttribute('data-passed'); }
          if (k === i) { st.g.setAttribute('data-active', ''); } else { st.g.removeAttribute('data-active'); }
        });
        Array.prototype.forEach.call(reads, function (r, k) { r.classList.toggle('is-active', k === i); });
        if (done) { done.style.strokeDasharray = (stations[i].t * 1000).toFixed(1) + ' 1000'; }
        if (idxEl) idxEl.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      }

      var timer = null, inView = false, held = false;
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function resume() {
        if (reduce || timer || !inView || held) return;
        timer = setInterval(function () { go((active + 1) % n); }, DWELL);
      }
      function hold() { held = true; stop(); }
      function release() { held = false; resume(); }

      [root, readout].forEach(function (z) {
        z.addEventListener('mouseenter', hold);
        z.addEventListener('mouseleave', release);
        z.addEventListener('focusin', hold);
        z.addEventListener('focusout', release);
      });

      render(window.innerWidth <= COMPACT_AT);

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          var want = window.innerWidth <= COMPACT_AT;
          if (want !== compact) { render(want); }
        }, 180);
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            inView = e.isIntersecting;
            if (inView) { resume(); } else { stop(); }
          });
        }, { threshold: 0.2 }).observe(root);
      } else {
        inView = true; resume();
      }
    }

    function init() {
      var roots = document.querySelectorAll('[data-mpc-route]:not([data-mpc-built])');
      Array.prototype.forEach.call(roots, function (r) {
        r.setAttribute('data-mpc-built', '');
        requestAnimationFrame(function () { build(r); });  // needs layout for getPointAtLength
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merivo-ritual-chapters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mrc]').forEach(function (stage) {
      var root   = stage.parentElement;
      var videos = Array.prototype.slice.call(stage.querySelectorAll('[data-mrc-video]'));
      var caps   = Array.prototype.slice.call(stage.querySelectorAll('[data-mrc-caption]'));
      var tabs   = Array.prototype.slice.call(root.querySelectorAll('[data-mrc-tab]'));
      if (!videos.length || videos.length !== tabs.length) return;

      var reduce  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0, visible = false, raf = null;

      function arm(v) {
        if (v.dataset.armed) return;
        v.dataset.armed = '1';
        v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
        // preload="none" keeps the clip off the wire until it is wanted, but the
        // browser will not fetch a byte while it stays "none" - load() alone does
        // nothing and any wait for a media event deadlocks. Lift it when arming.
        v.preload = 'auto';
        v.load();
      }

      // Rewinding needs metadata to exist; playing does not. Gate only the
      // rewind, and never gate the play() itself.
      function start(v, restart) {
        var go = function () {
          if (restart) { try { v.currentTime = 0; } catch (e) {} }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        };
        if (!restart || v.readyState >= 1) go();
        else v.addEventListener('loadedmetadata', go, { once: true });
      }

      // "12.4 | Fill with ice" per line. Parsed once, then the line is only
      // rewritten when the active step actually changes, not every frame.
      var stepSets = caps.map(function (c) {
        var raw = c.querySelector('[data-mrc-line]') &&
                  c.querySelector('[data-mrc-line]').getAttribute('data-steps');
        if (!raw) return null;
        var out = raw.split('\n').map(function (line) {
          var i = line.indexOf('|');
          if (i < 0) return null;
          var t = parseFloat(line.slice(0, i));
          var text = line.slice(i + 1).trim();
          return isNaN(t) ? null : { t: t, text: text };
        }).filter(Boolean).sort(function (a, b) { return a.t - b.t; });
        return out.length ? out : null;
      });
      var shownStep = caps.map(function () { return -1; });

      function paintSteps() {
        var steps = stepSets[index];
        if (!steps) return;
        var t = videos[index].currentTime, n = 0;
        for (var i = 0; i < steps.length; i++) if (t >= steps[i].t) n = i;
        if (n === shownStep[index]) return;
        shownStep[index] = n;
        var line = caps[index] && caps[index].querySelector('[data-mrc-line]');
        if (line) line.textContent = steps[n].text;
      }

      function paint() {
        paintSteps();
        var v = videos[index];
        var d = v.duration;
        tabs.forEach(function (tab, i) {
          var fill = tab.querySelector('.mrc__tab-fill');
          if (!fill) return;
          var pct = i !== index ? 0
                  : (d && isFinite(d) ? Math.min(1, Math.max(0, v.currentTime / d)) : 0);
          fill.style.transform = 'scaleX(' + pct + ')';
        });
        raf = requestAnimationFrame(paint);
      }

      // `restart` is only true for a deliberate pick. The observer resumes
      // instead: it can fire several times while a scroll settles, and rewinding
      // on every fire pinned the clip at 0 and looked like playback was dead.
      function show(n, restart) {
        index = n;
        videos.forEach(function (v, i) {
          var on = i === n;
          v.classList.toggle('is-active', on);
          if (on) {
            arm(v);
            if (!reduce) start(v, restart);
          } else {
            try { v.pause(); } catch (e) {}
          }
        });
        tabs.forEach(function (tab, i) {
          tab.classList.toggle('is-active', i === n);
          tab.setAttribute('aria-selected', i === n ? 'true' : 'false');
        });
        caps.forEach(function (c, i) { c.classList.toggle('is-active', i === n); });
        if (typeof shownStep !== 'undefined') shownStep[n] = -1;
        // Warm the next chapter so the hand-off does not stall on a cold start.
        var next = videos[(n + 1) % videos.length];
        if (next !== videos[n]) arm(next);
      }

      videos.forEach(function (v, i) {
        v.addEventListener('ended', function () {
          if (visible) show((i + 1) % videos.length, true);
        });
      });

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { show(i, true); });
      });

      function run() {
        show(index, false);
        if (raf === null) raf = requestAnimationFrame(paint);
      }
      function halt() {
        videos.forEach(function (v) { try { v.pause(); } catch (e) {} });
        if (raf !== null) { cancelAnimationFrame(raf); raf = null; }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) run(); else halt();
          });
        }, { threshold: 0.25 }).observe(stage);
      } else { visible = true; run(); }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) halt(); else if (visible) run();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merivo-ritual-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init() {
      if (!('IntersectionObserver' in window)) return;
      var vids = document.querySelectorAll('.merivo-ritual__step-video:not([data-ritual-bound])');
      if (!vids.length) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting && !reduce) {
            if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
            v.play().catch(function () {});
          } else {
            try { v.pause(); } catch (e) {}
          }
        });
      }, { threshold: 0.25, rootMargin: '100px' });

      Array.prototype.forEach.call(vids, function (v) {
        v.setAttribute('data-ritual-bound', '');
        io.observe(v);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merivo-video-cycle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mvc]').forEach(function (stage) {
      var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-mvc-slide]'));
      var dots   = Array.prototype.slice.call(stage.querySelectorAll('[data-mvc-dot]'));
      if (slides.length < 2) {
        var only = stage.querySelector('[data-mvc-shared]') ||
                   (slides[0] && slides[0].querySelector('[data-mvc-video]'));
        if (only && only.play) only.play().catch(function () {});
        return;
      }

      var shared = stage.querySelector('[data-mvc-shared]');
      var dwellSeconds = parseFloat(stage.getAttribute('data-dwell')) || 6;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0, timer = null, visible = false;

      function video(n) { return slides[n].querySelector('[data-mvc-video]'); }

      function show(n) {
        index = n;
        slides.forEach(function (s, i) {
          var on = i === n;
          s.classList.toggle('is-active', on);
          if (shared) return; // one continuous clip: never touch it on a caption change
          var v = s.querySelector('[data-mvc-video]');
          if (!v || !v.play) return;
          // Only the visible slide holds a decoding video.
          if (on && visible && !reduce) { v.play().catch(function () {}); }
          else { try { v.pause(); } catch (e) {} }
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === n);
          d.setAttribute('aria-selected', i === n ? 'true' : 'false');
          var f = d.querySelector('.mvc__dot-fill');
          if (f) f.style.setProperty('--mvc-progress', 0);
        });
        var av = video(n);
        if (av && av.tagName === 'VIDEO') { try { av.currentTime = 0; } catch (e) {} }
        stillStart = Date.now();
      }

      function fillEl(n) {
        return dots[n] ? dots[n].querySelector('.mvc__dot-fill') : null;
      }
      function setFill(n, pct) {
        var f = fillEl(n);
        if (f) f.style.setProperty('--mvc-progress', Math.max(0, Math.min(1, pct || 0)));
      }
      function slideDwell(n) {
        var v = parseFloat(slides[n].getAttribute('data-slide-dwell'));
        return (v > 0 ? v : dwellSeconds) * 1000;
      }

      /* A clip and a still need different clocks. A video reports its own
         duration, so the bar reads currentTime/duration and the clip's 'ended'
         hands over. A still has no duration, so it falls back to a timer. */
      var raf = null, stillStart = Date.now();
      function tick() {
        var v = video(index);
        if (v && v.tagName === 'VIDEO' && v.duration && isFinite(v.duration)) {
          setFill(index, v.currentTime / v.duration);
        } else {
          setFill(index, (Date.now() - stillStart) / slideDwell(index));
        }
        raf = requestAnimationFrame(tick);
      }

      function start() {
        if (reduce) return;
        if (raf === null) raf = requestAnimationFrame(tick);
        var v = video(index);
        if (v && v.tagName === 'VIDEO') return;  /* its 'ended' advances it */
        if (timer) return;
        timer = setTimeout(function () {
          timer = null;
          show((index + 1) % slides.length);
          start();
        }, slideDwell(index));
      }
      function stop() {
        if (timer) { clearTimeout(timer); timer = null; }
        if (raf !== null) { cancelAnimationFrame(raf); raf = null; }
      }

      slides.forEach(function (sl, i) {
        var v = sl.querySelector('[data-mvc-video]');
        if (!v || v.tagName !== 'VIDEO') return;
        v.loop = false;  /* a looping clip never fires 'ended' */
        v.addEventListener('ended', function () {
          if (!visible || index !== i) return;
          show((index + 1) % slides.length);
          start();
        });
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          stop();
          start(); // restart the dwell so a manual pick gets a full turn
        });
      });

      // Never decode video for a section nobody is looking at.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible) {
              if (shared && !reduce) { shared.play().catch(function () {}); }
              show(index); start();
            } else {
              stop();
              if (shared && shared.pause) { try { shared.pause(); } catch (e) {} }
              slides.forEach(function (s) {
                var v = s.querySelector('[data-mvc-video]');
                if (v && v.pause) { try { v.pause(); } catch (e) {} }
              });
            }
          });
        }, { threshold: 0.25 }).observe(stage);
      } else {
        visible = true; show(0); start();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else if (visible) { show(index); start(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
